import aggregateModels from './aggregate-models'
import elections from './elections'
import geojson from './geojson'
import landingModels from './landing-models'
import persistentUx from './persistent-ux'
import ux from './ux'
import race from './race'

export default {
    aggregateModels,
    elections,
    geojson,
    landingModels,
    persistentUx,
    ux,
    race,
}
